import { useNavigate } from "react-router-dom";
import { logout } from "@/lib/api/auth";
import { dayStore } from "@/features/mobile/offline/dayStore";
import { useAsyncAction } from "@/lib/hooks/useAsyncAction";
import { ANONYMOUS_BOOTSTRAP, useSession } from "@/lib/session/SessionContext";

/**
 * Abmelden aus dem Mandanten-Bereich (`/app/*`): Server-Sitzung beenden,
 * Offline-Bestand verwerfen, Bootstrap zurücksetzen, zum Login. Der
 * Server-Aufruf darf scheitern — die lokale Sitzung wird trotzdem verworfen,
 * sonst bliebe man auf einer Seite hängen, deren Daten nicht mehr geladen werden
 * können.
 *
 * Die eine Stelle für diesen Ablauf (Gatter G3): er stand in vier Dateien
 * wortgleich.
 *
 * **Der Tagesbestand geht hier weg** (Nachtrag zu S4.3). Seit der
 * Sitzungshinweis einen Kaltstart ohne Netz übersteht (lib/session/
 * offlineSession.ts), überstünde ihn sonst auch der Bestand — und der hängt am
 * Datum, nicht am Mitglied: der nächste Mensch am selben Gerät sähe die Aufträge
 * des vorigen, sobald sein erster Netzaufruf scheitert. Die Warteschlange bleibt
 * bewusst stehen (siehe dayStore#verwirfBestand).
 *
 * Reihenfolge: erst räumen, dann den Zustand ersetzen. Andersherum stünde das
 * Räumen hinter einer Navigation, die die Komponente schon abgebaut hat.
 */
export function useMemberLogout() {
  const { applyBootstrap } = useSession();
  const { run, pending } = useAsyncAction();
  const navigate = useNavigate();

  const handleLogout = () =>
    run(async () => {
      await logout().catch(() => {});
      // Ein gesperrter Gerätespeicher darf die Abmeldung nicht aufhalten: die
      // Sitzung ist beim Server bereits beendet.
      await dayStore.verwirfBestand().catch(() => {});
      applyBootstrap(ANONYMOUS_BOOTSTRAP);
      navigate("/login", { replace: true });
    });

  return { handleLogout, pending };
}
